import { useQuery } from '@apollo/client';
import { graphql } from '@packages/charka-common-ui/graphql/types';

const QUERY = graphql(`
  query PrintRule($id: ID!) {
    printRule(id: $id) {
      id
      name
      printerDeviceId
      menu {
        sections {
          id
          name
          code
        }
      }
      pages {
        id
        name
        printerDeviceId
        allowedSections {
          pageRuleId
          menuSectionId
          menuSection {
            code
            id
            name
          }
        }
      }
    }
  }
`);

export function usePrintRule(id: string) {
  return useQuery(QUERY, {
    variables: {
      id,
    },
  });
}
